// extracted by mini-css-extract-plugin
export var cardHeader = "_eq-0";
export var reorderHandle = "_eq-3";
export var titleArea = "_eq-1";
export var titleAreaWithHandle = "_eq-2";